import { Injectable } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import {
  LOCAL_STORAGE_SESSION_TOKEN_KEY,
  LOCAL_STORAGE_SESSION_TOKEN_EXPIRES_AT_KEY,
} from '../core/constants'
import { CUSTOM_STATUS_CODES } from '../../@core/utils/constants'
import { LOGIN_PATHS } from '../../@core/utils/path'

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle token invalid error (statusCode 900)
        if (error.error && error.error.statusCode === CUSTOM_STATUS_CODES.TOKEN_INVALID) {
          delete window['_sessionToken']
          localStorage.removeItem(LOCAL_STORAGE_SESSION_TOKEN_KEY)
          localStorage.removeItem(LOCAL_STORAGE_SESSION_TOKEN_EXPIRES_AT_KEY)
          const currentPath = globalThis.location.pathname
          const isAdminPath = currentPath.includes('/admin')
          
          const loginPath = isAdminPath ? LOGIN_PATHS.ADMIN : LOGIN_PATHS.MERCHANT
          this.router.navigate([loginPath]).then(() => {
            globalThis.location.reload()
          })
          
          return throwError(error.error)
        }

        if (error.error && error.error.message) {
          return throwError(error.error)
        }

        // If you want to return the error on the upper level:
        return throwError(error)
      })
    )
  }
}